import React from 'react';
import _ from 'underscore';
import { GENERAL } from '../constants';

export default ({
    professionalSummary,
    statesLicensing,
    statesLicensingLabel,
    areasServed,
    areasServedLabel,
    languages,
    languagesLabel,
    includeBrokercheckLink
}) => (
    <div className="c-profile__summary profile-summary">
        {professionalSummary &&
            <p className="profile-summary__professional-summary">{professionalSummary}</p>
        }

        {statesLicensing &&
            <p className="profile-summary__states-licensing">
                <strong className="profile-summary__states-licensing-label">{statesLicensingLabel}:</strong>
                <span className="profile-summary__states-licensing__spacing">&nbsp;</span>
                <small className="profile-summary__states-licensed">{statesLicensing}</small>
            </p>
        }

        {areasServed &&
            <p><strong>{areasServedLabel}:</strong> <small>{areasServed}</small></p>
        }

        {_.isArray(languages) &&
            <p><strong>{languagesLabel}:</strong> <small>{languages.join(", ")}</small></p>
        }

        {includeBrokercheckLink &&
            <em>
                {GENERAL.BROKER_CHECK.TITLE}
                <a
                    href={GENERAL.BROKER_CHECK.ANCHOR_URL}
                    target="_blank"
                    rel="noopener"
                    title={GENERAL.BROKER_CHECK.ANCHOR_TITLE}
                >
                    {GENERAL.BROKER_CHECK.ANCHOR_TEXT}
                </a>
            </em>
        }
    </div>
);



// WEBPACK FOOTER //
// ./components/profile/profile_summary.jsx